import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FeedbackQuestionSurvey } from '../providers/question-provider';
import { AnswerProvider, FeedbackAnswerSurvey } from '../providers/answer-provider';

import { FeedbackQuestionFactoryService } from '../questions/feedback-question-factory.service';
import { FeedbackQuestionService } from '../questions/feedback-question.service';
import { Subscription } from 'rxjs';
import { Feedback } from "../../common/models/feedback";

@Directive()
export abstract class BaseAnswer implements OnInit, OnDestroy {
    @Input()
    public hasAnsweredQuestion = false;

    @Input()
    public feedback: Feedback = {} as Feedback;

    @Input()
    public question: FeedbackQuestionSurvey = {} as FeedbackQuestionSurvey;

    @Output()
    public onAnswerChange: EventEmitter<any> = new EventEmitter();

    @Input()
    public previousAnswers: any = null;

    @Output()
    public onNextQuestionClicked: EventEmitter<{answers: FeedbackAnswerSurvey[]; isBack: boolean}> = new EventEmitter();

    public feedbackAnswers: FeedbackAnswerSurvey[] = [];

    public userAnswers: FeedbackAnswerSurvey[] = [];

    public isSubmitting = false;

    public feedbackAnswersPopulatedEvent: EventEmitter<any> = new EventEmitter();
    protected subscriptions: Subscription[] = [];

    constructor(
        protected answerProvider: AnswerProvider,
        protected feedbackQuestionFactoryService: FeedbackQuestionFactoryService,
        protected feedbackQuestionService: FeedbackQuestionService
    ) {
        this.subscriptions.push(
            feedbackQuestionFactoryService.submitSubject.subscribe((res) => {
                this.isSubmitting = res;
            })
        );
    }

    public ngOnInit(): void {
        this.populateAnswers();
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    /**
     * Add user selected answers to an array and emit answer changed event.
     *
     * @param answer    The answer to add to user answers array
     * @param unique    Where or not answers array can have multiple answers
     * @param dataValue Answer dataValue replacement
     */
    public answerChanged(answer: any | null, unique = true, dataValue: any = null): void {
        // if no multiple answers is allowed
        if (unique) {
            this.userAnswers = [];
        }

        if (null !== dataValue) {
            answer.userData = dataValue;
        }

        // add answer to user answers array without duplicates !
        const temp = this.userAnswers;
        temp.push(answer);
        this.userAnswers = Array.from(new Set(temp));

        this.onAnswerChange.emit(answer);
    }

    public nextQuestionClicked(isBackButton = false): void {
        this.onNextQuestionClicked.emit({answers: this.userAnswers, isBack: isBackButton});
    }

    public isNextQuestionEnabled(): boolean {
        return this.userAnswers.length > 0  || this.previousAnswers !== null;
    }

    protected populateAnswers() {
        this.subscriptions.push(
            this.answerProvider.findAllByQuestionId(this.feedback.id!, this.question.id).subscribe((feedbackAnswerSurvey: FeedbackAnswerSurvey[]) => {
                this.feedbackAnswers = feedbackAnswerSurvey;
                this.feedbackAnswersPopulatedEvent.emit();
            })
        );
    }
}

export default BaseAnswer;
